<template>
  <div class="page-wrapper">
    <div class="viewpage-caption-container clearFix">
      <div class="title">Inventory Reports</div>
    </div>
    <el-tabs v-model="activeTabName" @tab-click="handleClick" type="border-card">
      <el-tab-pane name="first">
        <span slot="label">
          <i class="el-icon-document"></i> Transfers Detail
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingInv :showOutInWarehouse="true" :showWarehouseChk="false" />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="second">
        <span slot="label">
          <i class="el-icon-notebook-2"></i> Adjustments Detail
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingInv />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label">
          <i class="el-icon-coin"></i> Inventory Classification Summary
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingInv />
          <ReportProducts />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="fourth">
        <span slot="label">
          <i class="el-icon-coin"></i> Inventory Items Trace Detail
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingInv :showWarehouseChk="true" />
          <ReportProducts />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportProducts from '../components/ReportProducts'
import ReportBasicSettingInv from '../components/ReportBasicSettingInv'
import { mapActions } from 'vuex'

export default {
  name: 'reportInventory',
  components: {
    ReportProducts,
    ReportBasicSettingInv
  },
  created () {
    this.initTransDetails()
  },
  data () {
    return {
      activeTabName: 'first',
      tabsVifFlag: 1
    }
  },
  methods: {
    ...mapActions({
      initTransDetails: 'report/initTransDetails',
      initAjDetails: 'report/initAjDetails',
      initInventorySummary: 'report/initInventorySummary',
      initInventoryDetails: 'report/initInventoryDetails',
      queryInventoryDetails: 'report/inventoryDetails'
    }),
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.tabsVifFlag = 1
        this.initTransDetails()
      } else if (tab.name === 'second') {
        this.tabsVifFlag = 2
        this.initAjDetails()
      } else if (tab.name === 'third') {
        this.tabsVifFlag = 3
        this.initInventorySummary()
      } else if (tab.name === 'fourth') {
        this.tabsVifFlag = 4
        this.initInventoryDetails()
      }
    },
    async handleSubmit () {
      // todo
      await this.queryInventoryDetails()
      this.$message({
        message: 'Preparing for the report, please check it later',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  text-align: left;
  max-width: 1660px;
}
.viewpage-caption-container {
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  float: left;
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.btn,
.btn-secondary {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.clearFix::after {
  content: "";
  display: block;
  height: 0;
  clear: both;
}
.submit {
  margin-top: 20px;
}
</style>
